import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {Notice, NoticeState} from './type'
import NOTICE_TYPES from '@/constants/notice-types'
import {updateAll} from '@/store/utils'

const initState: NoticeState = {
  list: [],
  listNextOffset: null,
  card: [],
  popup: [],
}

const module: ModuleFc<NoticeState> = (ctx) => ({
  namespaced: true,
  state: cloneDeep(initState),
  actions: {
    async getNoticeList({dispatch}) {
      await dispatch('getNotice', {type: NOTICE_TYPES.LIST})
    },
    async getNoticeCard({dispatch}) {
      await dispatch('getNotice', {type: NOTICE_TYPES.CARD})
    },
    async getNoticePopup({dispatch}) {
      await dispatch('getNotice', {type: NOTICE_TYPES.POPUP})
    },
    async getNotice({commit, state}, payload = {}) {
      const {
        type = NOTICE_TYPES.LIST,
        limit = 10,
        offset = NOTICE_TYPES.LIST === type ? Number(state.listNextOffset) : 0,
      } = payload
      const {storeName, paramName} = type
      const result = await ctx.$axios({
        url: '/notice',
        method: 'get',
        params: {
          displayType: paramName,
          limit,
          offset
        }
      })
      commit(`updateNotice${storeName}`, {
        list: result.data.results, offset: result.data.nextOffset
      })
    },
  },
  getters: {
    isEmptyList(state) {
      return 0 === state.list?.length
    },
    homeNotice(state) {
      return state.card?.[0] || null
    },
    popupNotice(state) {
      return state.popup?.[0] || null
    },
  },
  mutations: {
    updateNoticeList(state, payload: {list: Notice[], offset: number}) {
      updateAll(state.list, payload.list)
      state.listNextOffset = payload.offset
    },
    updateNoticeCard(state, payload: {list: Notice[]}) {
      updateAll(state.card, payload.list)
    },
    updateNoticePopup(state, payload: {list: Notice[]}) {
      updateAll(state.popup, payload.list)
    },
  }
})

export {NoticeState}

export default module
